export enum SystemRole {
    SystemUser = "SystemUser",
    SystemOwner = "SystemOwner",
}
